import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateAssetReservationDto } from '../../dtos/create-asset-reservation.dto';
import { UpdateAssetReservationDto } from '../../dtos/update-asset-reservation.dto';
import { createAssetReservationSchema } from '../schemas/create-asset-reservation.schema';
import { updateAssetReservationSchema } from '../schemas/update-asset-reservation.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateAssetReservationDto | UpdateAssetReservationDto,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// Determine if it's an update or create operation by checking for 'id'
	if ('id' in record && record.id) {
		// Validate against updateAssetReservationSchema if 'id' is present
		validationResult = updateAssetReservationSchema().validate(record, {
			abortEarly,
		});
	} else {
		// Validate against createAssetReservationSchema if 'id' is not present
		validationResult = createAssetReservationSchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
